function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import axios from 'axios';
import React from 'react';
import { parseDataUrl } from "../../utils";
import { ViewArchiveErrorType } from "../view-archive.vm";
import mime from 'mime';
export const useArchiveMimeType = archive => {
  const {
    file,
    blob,
    httpUrl,
    staticUrl,
    dataUrl,
    base64,
    uInt8
  } = archive;
  const [mimeType, setMimeType] = React.useState(null);
  const [error, setError] = React.useState(null);
  const setMimeTypeWithCharset = React.useCallback(mimeWithCharset => {
    if (!mimeWithCharset) setError(ViewArchiveErrorType.MIME_TYPE_ERROR);else {
      const mime = mimeWithCharset.split(';')[0];
      setMimeType(mime);
    }
  }, []);
  const urlToMimeType = React.useCallback((url, mime, config) => {
    if (mime) setMimeTypeWithCharset(mime);else {
      axios.head(url, _objectSpread({
        withCredentials: true
      }, config)).then(response => {
        const mimeWithCharset = response.headers['content-type'];
        if (mimeWithCharset) setMimeTypeWithCharset(mimeWithCharset);
      }).catch(() => setError(ViewArchiveErrorType.HTTP_MIME_TYPE_ERROR));
    }
  }, []);
  React.useEffect(() => {
    var _mime$getType;
    if (file) setMimeTypeWithCharset(file.type || ((_mime$getType = mime.getType(file.name)) !== null && _mime$getType !== void 0 ? _mime$getType : ''));else if (blob) setMimeTypeWithCharset(blob.type);else if (httpUrl) urlToMimeType(httpUrl.url, httpUrl.mime, httpUrl.config);else if (dataUrl) setMimeTypeWithCharset(parseDataUrl(dataUrl).mime);else if (base64) setMimeTypeWithCharset(base64.mime);else if (uInt8) setMimeTypeWithCharset(uInt8.mime);else if (staticUrl) urlToMimeType(staticUrl.url, staticUrl.mime);else setError(ViewArchiveErrorType.NO_ARCHIVE);
  }, [archive]);
  return {
    mimeType,
    error
  };
};